// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 554 ? "effa34c9" : chunkId) + "." + {"470":"6f30d8db08d0adf0dd85","554":"1981439d8aa7f5c7752a","757":"58068d745434871263a6"}[chunkId] + ".js";
};